import { Sparkles, CheckCircle2 } from "lucide-react";

export default function GeneratorThinkingPanel({
    mode = "autofill",
    status = "",
    active = false
}) {
    const autofillSteps = [
        "Understanding your business",
        "Detecting industry pattern",
        "Mapping website strategy",
        "Preparing AI suggestions"
    ];

    const generationSteps = [
        "Reading project details",
        "Choosing structure and layout",
        "Generating content and sections",
        "Preparing preview experience"
    ];

    const steps = mode === "generation" ? generationSteps : autofillSteps;

    const normalizedStatus = String(status || "").toLowerCase();

    let activeIndex = 0;

    if (mode === "generation") {
        if (normalizedStatus.includes("preparing")) activeIndex = 1;
        if (normalizedStatus.includes("submitted")) activeIndex = 2;
        if (normalizedStatus.includes("generating")) activeIndex = 2;
        if (normalizedStatus.includes("generated")) activeIndex = 3;
    } else {
        activeIndex = active ? 2 : 0;
    }

    return (
        <div className="gtp-shell">
            <div className="gtp-head">
                <div className="gtp-badge">
                    <Sparkles size={16} />
                    <span>{mode === "generation" ? "AI Generation" : "AI Suggestions"}</span>
                </div>

                <div className="gtp-title">
                    {mode === "generation"
                        ? "AI is preparing your website preview"
                        : "AI is analyzing your business details"}
                </div>

                <div className="gtp-subtitle">
                    {mode === "generation"
                        ? "We’re shaping the layout, content, and preview structure based on your industry and inputs."
                        : "We’re identifying your business type, strategy, and page structure from the essentials you entered."}
                </div>
            </div>

            <div className="gtp-steps">
                {steps.map((step, index) => {
                    const completed = index < activeIndex;
                    const current = index === activeIndex;

                    return (
                        <div
                            key={step}
                            className={`gtp-step ${completed ? "completed" : ""} ${current ? "current" : ""}`}
                        >
                            <div className="gtp-step-icon">
                                {completed ? <CheckCircle2 size={16} /> : <span />}
                            </div>

                            <div className="gtp-step-copy">
                                <strong>{step}</strong>
                                <span>
                                    {completed
                                        ? "Done"
                                        : current
                                            ? "In progress"
                                            : "Queued"}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}